import * as careRuleset from './care.ruleset';
import { CareActionType, CareItemType } from './care.ruleset';
import { careSchema } from './care.schema';
import { careActions } from './care.actions';
import { careGetters } from './care.getters';
import { careModifiers } from './care.modifiers';
import { Inventory } from '../inventory';
import { Pet } from '../pet';
import { visitSchema } from '../../visit/visit.schema';
import { Immutable, SB } from '@play-co/replicant';
import { ReplicantModuleState } from '../../utils';
import { PetStats } from '../pet/stats';
import { Fate } from '../fate';

namespace Visit {
  export const schema = visitSchema;

  type State = Immutable<SB.ExtractType<SB.ObjectSchema<typeof schema>>>;
  export const getters = (state: State) => ({
    isVisiting: () => !!state.visit.visitSession,
  });
}

export type Care = typeof Care;
// eslint-disable-next-line no-redeclare
export namespace Care {
  export const $DEPENDENCIES = { Pet, PetStats, Inventory, Visit, Fate };

  export const ruleset = careRuleset;
  export const schema = careSchema;
  export const getters = careGetters(Care, $DEPENDENCIES);
  export const modifiers = careModifiers;
  export const actions = careActions(Care, $DEPENDENCIES);

  export type MutableState = ReplicantModuleState<Care>;
  export type State = Immutable<MutableState>;
  export type ActionType = CareActionType;
  export type ItemType = CareItemType;
}
